import React from 'react'

export default function Site() {
  return (
    <div className="site">
      Empty Site Component 
    </div>
  )
}
